import { tx as translateInterfaceText } from '@/utils/i18n';
import { format, addMinutes, isAfter, parseISO } from 'date-fns';
import { toZonedTime, fromZonedTime } from 'date-fns-tz';
import { JITSchedule } from '@/store/webinar/types';

// Arredondar para próximo intervalo
export const roundToNextInterval = (
  date: Date,
  intervalMin: number,
  minWaitMin: number
): Date => {
  const now = addMinutes(date, minWaitMin);
  const minutes = now.getMinutes();
  const nextSlot = Math.ceil(minutes / intervalMin) * intervalMin;
  const rounded = new Date(now);
  rounded.setMinutes(nextSlot, 0, 0);
  return rounded;
};

// Verificar se horário está em quiet hours
export const isInQuietHours = (
  date: Date,
  quietHours?: { from: string; to: string }
): boolean => {
  if (!quietHours) return false;
  const time = format(date, 'HH:mm');
  return time >= quietHours.from && time <= quietHours.to;
};

// Validar horário mínimo (agora + 10 min)
export const validateMinStartTime = (startAt: string): boolean => {
  const now = new Date();
  const minStart = addMinutes(now, 10);
  return isAfter(parseISO(startAt), minStart);
};

// Gerar slots JIT
export const generateJITSlots = (
  config: JITSchedule,
  count: number = 3
): Date[] => {
  const now = new Date();
  const slots: Date[] = [];
  let current = roundToNextInterval(now, config.interval_min, config.min_wait_min);
  let attempts = 0;
  const maxAttempts = 50;
  
  while (slots.length < count && attempts < maxAttempts) {
    attempts++;
    
    if (!isInQuietHours(current, config.quiet_hours)) {
      slots.push(new Date(current));
    }
    current = addMinutes(current, config.interval_min);
  }
  
  return slots;
};

// Fusos horários comuns
export const COMMON_TIMEZONES = [
  { get label() { return translateInterfaceText("Brasília (GMT-3)"); }, value: 'America/Sao_Paulo' },
  { get label() { return translateInterfaceText("Nova York (GMT-5)"); }, value: 'America/New_York' },
  { get label() { return translateInterfaceText("Los Angeles (GMT-8)"); }, value: 'America/Los_Angeles' },
  { get label() { return translateInterfaceText("Londres (GMT+0)"); }, value: 'Europe/London' },
  { get label() { return translateInterfaceText("Paris (GMT+1)"); }, value: 'Europe/Paris' },
  { get label() { return translateInterfaceText("Tóquio (GMT+9)"); }, value: 'Asia/Tokyo' },
  { get label() { return translateInterfaceText("Sydney (GMT+10)"); }, value: 'Australia/Sydney' },
  { get label() { return translateInterfaceText("Dubai (GMT+4)"); }, value: 'Asia/Dubai' },
  { get label() { return translateInterfaceText("Lisboa (GMT+0)"); }, value: 'Europe/Lisbon' },
];
